import { useEffect, type PropsWithChildren } from 'react';
import { useThemeStore } from '@/stores/theme';

// Aplica/quita la clase `.dark` en `<html>` cuando cambia `resolved`.
// El FOUC guard de `index.html` ya aplicó la clase antes del bundle;
// aquí mantenemos la sincronización en tiempo de ejecución.
export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const resolved = useThemeStore((s) => s.resolved);

  useEffect(() => {
    const root = document.documentElement;
    if (resolved === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [resolved]);

  return <>{children}</>;
};
